import { info, success, error } from './notification.js';
import { TYPES } from './types.js';

const state = {
  fields: {
    email: null,
    '$phone_number': null
  },
  set setField(field) {
    for (const name in field) {
      this.fields[name] = field[name];
    }
  }
};

export const newsletterSubmit = (event) => {
  if (event) event.preventDefault();

  const form = event.currentTarget;

  for (const name in state.fields) {
    const input = form.querySelector(`input[name="${name}"]`);

    if (input && input.value) {
      let field = {};
      field[name] = input.value;
      state.setField = field;
    }
  }

  klaviyo.identify({ 
    ...state.fields,
    'Accepts Marketing': true
  }, () => {
    klaviyo.track('Signed Up with Website Footer Newsletter Form', {
      signup_date: new Date().toISOString()
    });
  });

  const inputs = form.querySelectorAll('input');
  inputs.forEach((input) => {
    if (input.type !== 'submit') input.value = '';
  });

  success(window.Solver.newsletter.success_message);
};

export const newsletter = () => {
  window.Solver.newsletterSubmit = newsletterSubmit;
};
